import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

export const AI_AUDIO_USE_CREDIT = 10;

export const PRESET_STYLE_LIST = [
    { label: 'ttm-style-pop', value: 'ttm-style-pop' },
    { label: 'ttm-style-hip-hop', value: 'ttm-style-hip-hop' },
    { label: 'ttm-style-rock', value: 'ttm-style-rock' },
    { label: 'ttm-style-r&b', value: 'ttm-style-r&b' },
    { label: 'ttm-style-soul', value: 'ttm-style-soul' },
    { label: 'ttm-style-funk', value: 'ttm-style-funk' },
    { label: 'ttm-style-country', value: 'ttm-style-country' },
    { label: 'ttm-style-jazz', value: 'ttm-style-jazz' },
    { label: 'ttm-style-classical', value: 'ttm-style-classical' },
    { label: 'ttm-style-folk', value: 'ttm-style-folk' },
    { label: 'ttm-style-celtic', value: 'ttm-style-celtic' },
    { label: 'ttm-style-energetic', value: 'ttm-style-energetic' },
    { label: 'ttm-style-hype', value: 'ttm-style-hype' },
    { label: 'ttm-style-joyous', value: 'ttm-style-joyous' },
    { label: 'ttm-style-chill', value: 'ttm-style-chill' },
    { label: 'ttm-style-sad', value: 'ttm-style-sad' },
    { label: 'ttm-style-motivational', value: 'ttm-style-motivational' },
    { label: 'ttm-style-epic', value: 'ttm-style-epic' },
    { label: 'ttm-style-romantic', value: 'ttm-style-romantic' },
    { label: 'ttm-style-warm', value: 'ttm-style-warm' },
    { label: 'ttm-style-moody', value: 'ttm-style-moody' },
    { label: 'ttm-style-dark', value: 'ttm-style-dark' },
    { label: 'ttm-style-1960s', value: 'ttm-style-1960s' },
    { label: 'ttm-style-1970s', value: 'ttm-style-1970s' },
    { label: 'ttm-style-1980s', value: 'ttm-style-1980s' },
];

export const FJSliceAIAudioGenerator = createSlice({
    name: 'AIAudioGenerator',
    initialState: {
        tabIndex: 0, // 侧边栏 tab索引，0:文生音乐 t2m, 1:音生音乐 m2m, 2:文生音效 t2s
        subTabIndex: 0, // 子tab索引，0: 音乐，1:配乐
        historyTabIndex: 0, // 历史tab索引，0: 全部 1:音乐, 2:配乐, 3:音效

        incidentalAudioInfo: {}, // 参考配乐
        uploadIncidentalAudioStatus: FJConstant.DEFAULT,
        audioInfo: {}, // 参考音乐
        uploadAudioStatus: FJConstant.DEFAULT,
        vocalAudioInfo: {}, // 人声
        uploadVocalAudioStatus: FJConstant.DEFAULT,

        // 歌词
        lyricContent: '',
        lyricDesc: '',
        m2mLyricContent: '',
        t2mLyricContent: '',
        isEnableLyricsT2M: false,

        presetList: [],
        sfxPresetList: [],
        insPresetList: [],
        referenceMusicList: [],
        referenceVocalList: [],
        instrumentalList: [],
        isGenerateLyricsLoading: false,
        isMultipleMode: false,
        isDraggingVoiceFile: false,

        // prompt
        sfxPrompt: '',
        musicPrompt: '',
        instrumentalPrompt: '',

        // 免费次数
        musicToMusicFreeNum: 0, // 原 musicFreeNum
        musicToInstFreeNum: 0, // 原 intFreeNum
        sfxFreeNum: 0, // 保持不变

        textToMusicFreeNum: 0, // T2M - 音乐模式
        textToAccompanyFreeNum: 0, // T2M - 伴奏模式

        musicDuration: 120, // 默认120秒
        instrumentalDuration: 120, // 默认120秒配乐时长

        musicStyles: [],
        instrumentStyles: [],
    },
    reducers: {
        setSliceSFXFreeNumCreationAction: (state, action) => {
            state.sfxFreeNum = action.payload;
        },
        setSliceSFXPresetList: (state, action) => {
            state.sfxPresetList = action.payload;
        },
        setSliceInsPresetList: (state, action) => {
            state.insPresetList = action.payload;
        },
        setSliceHistoryTabIndex: (state, action) => {
            state.historyTabIndex = action.payload;
        },
        setSliceSFXPrompt: (state, action) => {
            state.sfxPrompt = action.payload;
        },
        setSliceIsMultipleMode: (state, action) => {
            state.isMultipleMode = action.payload;
        },
        setSliceIsGenerateLyricsLoading: (state, action) => {
            state.isGenerateLyricsLoading = action.payload;
        },
        setSliceIncidentalAudioInfo: (state, action) => {
            state.incidentalAudioInfo = action.payload;
        },
        setSliceAudioInfo: (state, action) => {
            state.audioInfo = action.payload;
        },
        setSliceVocalAudioInfo: (state, action) => {
            state.vocalAudioInfo = action.payload;
        },
        /**
         * @deprecated  旧版本更新歌词内容，请用 setSliceM2MLyricContent
         */
        setSliceLyricContent: (state, action) => {
            state.lyricContent = action.payload;
        },
        setSliceLyricDesc: (state, action) => {
            state.lyricDesc = action.payload;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceUploadAudioStatus: (state, action) => {
            state.uploadAudioStatus = action.payload;
        },
        setSliceVocalUploadAudioStatus: (state, action) => {
            state.uploadVocalAudioStatus = action.payload;
        },
        setSliceIncidentalAudioStatus: (state, action) => {
            state.uploadIncidentalAudioStatus = action.payload;
        },
        setSlicePresetList: (state, action) => {
            state.presetList = action.payload;
        },
        setSliceReferenceMusicList: (state, action) => {
            state.referenceMusicList = action.payload;
        },
        setSliceReferenceVocalList: (state, action) => {
            state.referenceVocalList = action.payload;
        },
        setSliceInstrumentalList: (state, action) => {
            state.instrumentalList = action.payload;
        },
        setSliceIsDraggingVoiceFile: (state, action) => {
            state.isDraggingVoiceFile = action.payload;
        },
        setSliceMusicDuration: (state, action) => {
            state.musicDuration = action.payload;
        },
        setSliceInstrumentalDuration: (state, action) => {
            state.instrumentalDuration = action.payload;
        },
        setSliceSubTabIndex: (state, action) => {
            state.subTabIndex = action.payload;
        },
        setSliceMusicStyles: (state, action) => {
            state.musicStyles = action.payload;
        },
        setSliceInstrumentStyles: (state, action) => {
            state.instrumentStyles = action.payload;
        },
        setSliceM2MLyricContent: (state, action) => {
            state.m2mLyricContent = action.payload;
        },
        setSliceT2MLyricContent: (state, action) => {
            state.t2mLyricContent = action.payload;
        },
        setSliceMusicPrompt: (state, action) => {
            state.musicPrompt = action.payload;
        },
        setSliceInstrumentalPrompt: (state, action) => {
            state.instrumentalPrompt = action.payload;
        },
        setSliceIsEnableLyricsT2M: (state, action) => {
            state.isEnableLyricsT2M = action.payload;
        },
        setSliceTextToMusicFreeNum: (state, action) => {
            state.textToMusicFreeNum = action.payload;
        },
        setSliceTextToAccompanyFreeNum: (state, action) => {
            state.textToAccompanyFreeNum = action.payload;
        },
        setSliceMusicToMusicFreeNum: (state, action) => {
            state.musicToMusicFreeNum = action.payload;
        },
        setSliceMusicToInstFreeNum: (state, action) => {
            state.musicToInstFreeNum = action.payload;
        },
    },
});

export const {
    setSliceLyricDesc,
    setSliceTabIndex,
    setSliceLyricContent,
    setSliceIncidentalAudioInfo,
    setSliceAudioInfo,
    setSliceVocalAudioInfo,
    setSliceUploadAudioStatus,
    setSliceVocalUploadAudioStatus,
    setSliceIncidentalAudioStatus,
    setSlicePresetList,
    setSliceReferenceMusicList,
    setSliceReferenceVocalList,
    setSliceInstrumentalList,
    setSliceIsGenerateLyricsLoading,
    setSliceIsMultipleMode,
    setSliceIsDraggingVoiceFile,
    setSliceSFXPrompt,
    setSliceHistoryTabIndex,
    setSliceSFXPresetList,
    setSliceInsPresetList,
    setSliceSFXFreeNumCreationAction,
    setSliceMusicDuration,
    setSliceInstrumentalDuration,
    setSliceSubTabIndex,
    setSliceMusicStyles,
    setSliceInstrumentStyles,
    setSliceM2MLyricContent,
    setSliceT2MLyricContent,
    setSliceMusicPrompt,
    setSliceInstrumentalPrompt,
    setSliceIsEnableLyricsT2M,
    setSliceTextToMusicFreeNum,
    setSliceTextToAccompanyFreeNum,
    setSliceMusicToMusicFreeNum,
    setSliceMusicToInstFreeNum,
} = FJSliceAIAudioGenerator.actions;

export default FJSliceAIAudioGenerator.reducer;
